import { useEffect, useState, useRef } from 'react';
import '../../assets/styles/_login.scss';
import { deliverSocialResult } from '../../common/utils';

const AppleCallback = () => {
  const [statusMessage, setStatusMessage] = useState('جاري التحقق من حسابك...');
  const [error, setError] = useState('');
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    const user = urlParams.get('user');
    const errorParam = urlParams.get('error');

    if (errorParam) {
      const errorMsg = `فشل تسجيل الدخول: ${errorParam}`;
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      deliverSocialResult('APPLE_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    if (!code) {
      const errorMsg = 'لم يتم استلام كود التفويض';
      setStatusMessage('حدث خطأ');
      setError(errorMsg);
      deliverSocialResult('APPLE_LOGIN_ERROR', { error: { message: errorMsg } }, 3000);
      return;
    }

    setStatusMessage('جاري إتمام تسجيل الدخول...');
    deliverSocialResult('APPLE_LOGIN_SUCCESS', { code, provider: 'apple', state, user });
  }, []);

  return (
    <div className="google-callback-container">
      <div className="loading-container">
        {!error && <div className="spinner" />}
        <h2 className="status-message">{statusMessage}</h2>
        {error && (
          <div className="error-container">
            <div className="error">{error}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AppleCallback;
